<template>
  <div>
    <div :class="['kilimall-choice-bar', `kilimall-choice-bar--${platform}`]" @click="popupVisible = true">
      <img
        class="choice-badge-img"
        :src="$cvWebpFn(CHOICE_ICONS.badge)"
        alt="Kilimall Choice"
      />
      <span class="choice-desc">Verified Quality &amp; Service</span>
      <van-icon name="arrow" class="choice-arrow" />
    </div>

    <KilimallChoicePopup v-model:visible="popupVisible" :platform="platform" />
  </div>
</template>

<script setup lang="ts">
import KilimallChoicePopup from './KilimallChoicePopup.vue'

withDefaults(defineProps<{
  platform?: 'wap' | 'pc'
}>(), {
  platform: 'wap'
})

const CHOICE_ICONS = {
  badge: 'https://image.kilimall.com/c/h5/KiliChoice.png'
}

const popupVisible = ref(false)
</script>

<style lang="scss" scoped>
.kilimall-choice-bar {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  background: #FFF4E8;
  border-radius: 4px;
  cursor: pointer;
}

.kilimall-choice-bar--wap {
  margin: 12px 0 4px;
}

.kilimall-choice-bar--pc {
  margin: 32px 0 0;
}

.choice-badge-img {
  flex-shrink: 0;
  display: block;
  height: 25px;
  width: auto;
  margin-right: 12px;
}

.kilimall-choice-bar--pc .choice-badge-img {
  height: 32px;
}

.choice-desc {
  flex: 1;
  min-width: 0;
  color: #B5691A;
  font-size: 24px;
  line-height: 32px;
  text-align: right;
}

.kilimall-choice-bar--pc .choice-desc {
  font-size: 28px;
  line-height: 40px;
}

.choice-arrow {
  flex-shrink: 0;
  margin-left: 8px;
  color: #B5691A;
  font-size: 24px;
}

.kilimall-choice-bar--pc .choice-arrow {
  font-size: 28px;
}
</style>
